import { Injectable } from '@angular/core';
import { LookupDataService } from '../../http/lookupdata.service';
import { Observable, forkJoin } from 'rxjs';

@Injectable()
export class ValidationService {

  constructor(private lookupdataService?: LookupDataService) { }

  // public MAXFAMILYMEMBERS = 5;
  // public MINADULTAGE = 25;
  // public MAXLIMITOFDAYSONSHORTTRIP = 183;
  
  //---------------------------------------------//
  // public MAXCHILDRENINFAMILY = 3;
  // public MAXADULTINFAMILY = 2;
  // public MAXIMUMTRAVELERAGE = 69;
  //---------------------------------------------//

  // public IMAGEUPLOADLIMIT = 2097152;

  

  // // added by vrushali
  public validationListLookUp: any[] = [];
  public activateOrganization = true;

  // public MAXPRODUCTCOMPARELIMIT = 3;
  // public BASEPLAN: String = "BASEPLAN";
  // public MOTOR: String = "MOTOR";
  // public PRODUCTCDPAP = "PA-P";
  // public PRODUCTCDPAD = "PA-D";
  // public PRODUCTCDTPL = "TPL";
  // public OPTIONAL: String = "OPTIONAL";
  // public AUTOFIRST: String = "AUTOFIRST";
  // public MAXTERMLIMIT = 5;

  //////////////////////////
  public validationConfig = [
    { fieldName: "genericEmail", required: false, maxlength: 140, minlength: null, pattern: "[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$" },
    { fieldName: "genericName", required: false, maxlength: 100, minlength: null, pattern: "^[A-Za-z]+[A-Za-z. ]*$" },
    { fieldName: "genericDob", required: false, maxlength: 10, minlength: 8, pattern: "^([0]?[1-9]|[1|2][0-9]|[3][0|1])[./-]([0]?[1-9]|[1][0-2])[./-]([0-9]{4}|[0-9]{2})$" },
    { fieldName: "genericMobileNum", required: false, maxlength: 17, minlength: 9, pattern: "[+]{0,1}[0-9]{0,3}[-]{0,1}[0-9]{9,17}$" },
    { fieldName: "genericLandlineNum", required: false, maxlength: 17, minlength: 7, pattern: "[+]{0,1}[0-9]{0,3}[-]{0,1}[0-9]{7,17}$" }
  ]

  public getFieldConfig(fieldName) {

    var fieldConfig = this.validationConfig.filter(field => {
      return field.fieldName === fieldName;
    })

    return fieldConfig[0];
  }

  public getMaxFamilyMembers() {
    return parseInt(this.getValidationValue("MAXFAMILYMEMBERS"))
  }

  public getMaxAdultsInFamily() {
    return parseInt(this.getValidationValue("MAXADULTINFAMILY"))
  }

  public getMaxChildrenInFamily() {
    return parseInt(this.getValidationValue("MAXCHILDRENINFAMILY"))
  }

  public getMaxChildAge() {
    return parseInt(this.getValidationValue("MINADULTAGE"))
  }

  public getMaxDaysLimitForShortTrip() {
    return parseInt(this.getValidationValue("MAXLIMITOFDAYSONSHORTTRIP"))
  }

  public getMaxAdultAge() {
    return parseInt(this.getValidationValue("MAXIMUMTRAVELERAGE"))
  }

  public getValidationLookup() {
    let lookupArr = ["ValidationListCd"];
    let observables = new Array();
    for (let item of lookupArr) {
      observables.push(this.lookupdataService.getLookup(item));
    }

    forkJoin(observables).subscribe(
      res => {
        let response: any[] = res;
        for (let lookupList of response) {
          if (lookupList[0].lookupCd == "ValidationListCd") {
            this.validationListLookUp = lookupList;
            console.log(" validationListLookUp " + JSON.stringify(this.validationListLookUp));
          }
        }
      },
      error => console.log('Error: ', error)
    );
  }

  public getValidationValue(lookupKey) {
    let lookupValue = null;
    this.validationListLookUp.forEach(validation => {
      if (validation.lookupKey === lookupKey)
        lookupValue = validation.lookupValue;
    });
      return lookupValue;
  }

}
